export const districtLists = [
  { value: "11", label: "PURNEA" },
  { value: "12", label: "ARARIA" },
  { value: "13", label: "KISHANGANJ" },
  { value: "14", label: "KATIHAR" },
  { value: "21", label: "MUNGER" },
  { value: "22", label: "JAMUI" },
  { value: "23", label: "LAKHISARAI" },
  { value: "24", label: "SHEIKHPURA" },
  { value: "25", label: "KHAGARIA" },
  { value: "26", label: "BEGUSARAI" },
  { value: "31", label: "BHAGALPUR" },
  { value: "32", label: "BANKA" },
  { value: "41", label: "SAHARSA" },
  { value: "42", label: "SUPAUL" },
  { value: "43", label: "MADHEPURA" },
  { value: "51", label: "MUZAFFARPUR" },
  { value: "52", label: "SITAMARHI" },
  { value: "53", label: "VAISHALI" },
  { value: "54", label: "BETTIAH" },
  { value: "55", label: "MOTIHARI" },
  { value: "56", label: "SHEOHAR" },
  { value: "61", label: "DARBHANGA" },
  { value: "62", label: "MADHUBANI" },
  { value: "63", label: "SAMASTIPUR" },
  { value: "71", label: "PATNA" },
  { value: "72", label: "NALANDA" },
  { value: "73", label: "BHOJPUR" },
  { value: "74", label: "ROHTAS" },
  { value: "75", label: "BUXAR" },
  { value: "76", label: "BHAHUA" },
  { value: "81", label: "GAYA" },
  { value: "82", label: "NAWADAH" },
  { value: "83", label: "AURANGABAD" },
  { value: "84", label: "JEHANABAD" },
  { value: "85", label: "ARWAL" },
  { value: "91", label: "SARAN" },
  { value: "92", label: "SIWAN" },
  { value: "93", label: "GOPALGANJ" },
];

export const dynamicStatus = (value) => {
  switch (value) {
    case "Approved":
      return "success";
    case "Pending":
      return "warning";
    default:
      return "error";
  }
};

export const SubjectCodes = {
  SSNK: "Sankrit",
  SBHO: "Bhojpuri",
  SNLH: "Hindi",
  SARB: "Arabic",
  MHND: "Hindi",
  MURD: "URDU",
  MMAI: "Maithli",
  MBNG: "Bangla",
  CMAT: "MAT-MATHEMATICS",
  CSCI: "SCI-SCIENCE",
  CSSC: "SSC-SOCIAL SCIENCE",
  CENG: "English",
};

export const emailRegex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,}$/;
